import React from 'react';
import { useDispatch } from 'react-redux';
import { createStore } from 'jotai';
import { initDrilldown } from '@store/trends/tempDashboard/nocDrilldown/actions';
import { dimensionPanelAtom, metricPanelAtom, summaryPanelAtom } from '@src/atoms/panels';
import { aiAlertAtom } from '@src/atoms/toggles';
import {
  diagnosticsModeAtom,
  dodAtom,
  layoutAtom,
  logAxisAtom,
  primaryFilterVisibilityAtom,
  sliceAreaAtom,
  unitAtom,
  percentileAtom,
  widgetPanelVisibilityAtom,
  yScaleModeAtom,
  zoomAreaAtom,
} from '@components/metrics-panel-hz/atoms';
import TempDashboardHoc from '../main/TempDashboardHoc';
import AppExperience from './index';
import { useCaseKeyAtom } from '@src/atoms/pageMeta';
import { isTableCompareEnabledAtom } from '@src/components/dimension-panel-hz/atoms/index';

//TODO: combine with initTrendsBasedStore
function initStore({ dashboard: state = {} }) {
  const store = createStore();

  if ('metricPanel' in state) {
    const {
      unit = '%',
      sliceArea = null,
      zoomArea = null,
      diagnosticsMode = false,
      logAxis = false,
      primaryFilterVisibility = true,
      layout = '4s',
      widgetPanelVisibility = false,
      percentile = 'avg',
      yScaleMode = false,
    }: any = state.metricPanel;
    store.set(layoutAtom, layout);
    store.set(unitAtom, unit);
    store.set(percentileAtom, percentile);
    store.set(yScaleModeAtom, yScaleMode);
    store.set(sliceAreaAtom, sliceArea);
    store.set(zoomAreaAtom, zoomArea);
    store.set(diagnosticsModeAtom, diagnosticsMode);
    store.set(logAxisAtom, logAxis);
    store.set(primaryFilterVisibilityAtom, primaryFilterVisibility);
    store.set(widgetPanelVisibilityAtom, widgetPanelVisibility);
  }

  if ('toggles' in state) {
    const { sections, diagnostics } = state.toggles;
    if (sections) {
      const { summary = true, metric = true, dimension = true } = sections;
      store.set(summaryPanelAtom, summary);
      store.set(metricPanelAtom, metric);
      store.set(dimensionPanelAtom, dimension);
    }

    if (diagnostics) {
      const { aiAlert = false, dod = false } = diagnostics;
      store.set(aiAlertAtom, aiAlert);
      store.set(dodAtom, dod);
    }
  }

  if ('isTableCompareEnabled' in state) {
    const { isTableCompareEnabled = false }: any = state;
    store.set(isTableCompareEnabledAtom, isTableCompareEnabled);
  }

  if ('usecaseKey' in state && !!state.usecaseKey) {
    store.set(useCaseKeyAtom, state.usecaseKey);
  }

  return store;
}

function AppExperienceDrilldownDashboard(props) {
  const dispatch = useDispatch();

  const applyCallback = (payload, doneCallback) => {
    dispatch(initDrilldown(payload.dashboard));
    doneCallback();
  };

  return (
    <TempDashboardHoc {...props} applyCallback={applyCallback} initStore={initStore}>
      {({ store }) => <AppExperience {...props} store={store} />}
    </TempDashboardHoc>
  );
}

export default AppExperienceDrilldownDashboard;
